import type { TileConfig } from '../config/types';

export default function Tile({ tile }: { tile: TileConfig }) {
  const isAvailable = tile.status === 'available';
  const Element = isAvailable ? 'a' : 'div';

  return (
    <Element
      {...(isAvailable ? { href: tile.href } : {})}
      className={`tile tile-${tile.status}`}
      aria-disabled={!isAvailable}
    >
      <div className="tile-icon">
        {tile.icon ? <img src={tile.icon} alt="" /> : <div className="tile-icon-placeholder" />}
      </div>
      <div className="tile-body">
        <div className="tile-header">
          <h3 className="tile-title">{tile.title}</h3>
          {tile.visibility === 'private' && (
            <span className="tile-badge tile-badge-private">PRIVATE</span>
          )}
          {tile.status === 'coming-soon' && (
            <span className="tile-badge tile-badge-soon">SOON</span>
          )}
        </div>
        <div className="tile-tags">
          {tile.tags.map((tag) => (
            <span key={tag} className="tile-tag">{tag}</span>
          ))}
        </div>
        <p className="tile-description">{tile.description}</p>
      </div>
    </Element>
  );
}
